import type * as React from "react";

import { cn } from "../lib/cn";

type PaperPanelVariant = "card" | "recessed";

const variantSurface: Record<PaperPanelVariant, string> = {
  card: "bg-card border border-rule",
  recessed: "bg-recess",
};

export interface PaperPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: PaperPanelVariant;
  /** Ignored by `recessed`. */
  lifted?: boolean;
  ref?: React.Ref<HTMLDivElement>;
}

/** The default paper surface, unpadded. */
export function PaperPanel({
  variant = "card",
  lifted = false,
  className,
  ...rest
}: PaperPanelProps) {
  const shadow =
    variant === "recessed"
      ? undefined
      : lifted
        ? "shadow-lift-lg"
        : "shadow-lift";

  return (
    <div
      className={cn(
        variantSurface[variant],
        "rounded-paper",
        shadow,
        className,
      )}
      {...rest}
    />
  );
}
